export type FormattedInputType =
    | 'currency'
    | 'integer'
    | 'float'
    | 'percent'
    | 'email'
    | 'text'
    | 'phone'
    | 'zipCode';

export * from './numeric';
export * from './options';
export * from './phone';
export * from './zipCode';
